import { stringify } from "../../util/querystring-util";
import {
  GetRootComponentsRequest,
  GetRootComponentsResponse,
  UpdateRootComponentsDeletionFlagsRequest,
  UpdateRootComponentsDeletionFlagsResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface RootComponentsRestResource {
  getRootComponents(
    request: GetRootComponentsRequest,
  ): Promise<GetRootComponentsResponse>;
  updateRootComponentsDeletionFlags(
    request: UpdateRootComponentsDeletionFlagsRequest,
  ): Promise<UpdateRootComponentsDeletionFlagsResponse>;
}

/**
 * GET /root-components
 */
const getRootComponents = restResourceRequester<
  GetRootComponentsRequest,
  GetRootComponentsResponse
>("GET", (request) => {
  return `/root-components?${stringify(request)}`;
});

/**
 * PUT /ms/item
 */
const updateRootComponentsDeletionFlags = restResourceRequester<
  UpdateRootComponentsDeletionFlagsRequest,
  UpdateRootComponentsDeletionFlagsResponse
>(
  "PUT",
  (_) => `/root-components/deletionFlags`,
  (request) => JSON.stringify(request),
);

export const RootComponentsRestResource: RootComponentsRestResource = {
  getRootComponents: getRootComponents,
  updateRootComponentsDeletionFlags: updateRootComponentsDeletionFlags,
};
